<template lang="pug">
div
	.position-relative
		//- Hero for FREE version
		section.section.section-lg.section-hero.heroPlastomex
			div(style='height: fit-content;')
				h1.h-titulo Galería
				p.lead.h-subtitulo  Dice más una imagen que mil palabras
	//- You write code for this content block in another  file

	//- 		:options="{ youTubeVideoIdProperty: 'youtube', youTubePlayerVars: undefined, youTubeClickToPlay: true}",

	gallery(
		:images='imagenesPro', 
		:index='index',  
		@close='index = null'
		)
	//-.galeria.row
		template(v-for='image, imageIndex in imagenes')
			figure.col-sm-6.col-lg-4(itemprop='associatedMedia', itemscope='', itemtype='http://schema.org/ImageObject')
				.zoom-container(@click='index = (image.id-1)')
					picture
						img(:src='image.poster', alt='Imagen de pruba', itemprop='thumbnail', )

				
	//-isotope(  ref="cpt" :options='{}', :list='imagenes2' v-images-loaded:on.progress="layout")
		div(v-for='image, imageIndex in imagenes2' :key='image.id')
			//-picture
			img(:src='image.poster', alt='Imagen de pruba', itemprop='thumbnail', )
	.container
		.row.text-center(:class="filtroClass")
			.col-12.col-md
				button.btn.btn-link(@click="filtro = /./ ") TODAS
			.col
				button.btn.btn-link(@click="filtro = /empresa/ ") Empresa
			.col 
				button.btn.btn-link(@click="filtro = /productos/ ") Productos
			.col 
				button.btn.btn-link(@click="filtro = /aplicaciones/ ") Aplicaciones

	.galeria.row
		template(v-for='image, imageIndex in imagenesPro')
			transition(name='fade')
				figure.col-sm-6.col-lg-4(v-show="filtro.test(image.tags)" itemprop='associatedMedia', itemscope='', itemtype='http://schema.org/ImageObject')
					.zoom-container(@click='index = imageIndex')
						picture
							source(:srcset='image.poster', type='image/webp')
							img(:src="`${image.poster.split('.')[0]}.jpg`", alt='Imagen de pruba', itemprop='thumbnail', )

	//-div(v-for='image, imageIndex in imagenes2' :key='image.id')
		transition(name='fade')
			picture(v-show="image.tags == filtro")
				img( :src='image.poster', width="30%" alt='Imagen de pruba', itemprop='thumbnail', )

</template>

<script>
//import Photoswipe from '@/views/components/Photoswipe.vue'
import VueGallery from 'vue-gallery';
//import { imagenesPro } from '../imagenes'

import isotope from 'vueisotope';
import imagesLoaded from 'vue-images-loaded'
 
export default {
	components: {
      'gallery': VueGallery,
			isotope
    },
	directives: {
				imagesLoaded,
		},
	data(){
		return{
		  	imagenesPro:[],
      	index: null,
			filtro: /-/
		}
	},
	computed:{
		filtrado(){
			return this.imagenesPro.filter( i => i.tags == this.filtro )
		},
		filtroClass(){
			if(this.filtro.toString() == '/-/')
				return 'sinSeleccion'
			else
				return 'Seleccion'
		}
	},
	methods:{
		layout () {
            this.$refs.cpt.layout('masonry');
        },
		fillImgs(){
			fetch('/data/imagenes.json')
			.then( response => response.json() )
			.then(data => this.imagenesPro = data)
			.catch( err => console.error(err ) )
		}
	},
	created() {
		this.fillImgs()
	}
}

</script>

<style lang="scss" scoped>
.heroPlastomex{
	background-image: url('/img/optimizadas/CAJAS.jpg');
}
.webp .heroPlastomex{
	background-image: url('/img/optimizadas/CAJAS.webp');
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.sinSeleccion{
	margin-top: 10em;
	margin-bottom: 10em;
	button {font-size: 2em;}
}
.Seleccion{
	margin-top: 2em;
	margin-bottom: 2em;
}
</style>